import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { SortDialog } from '@ifca-root/react-component/src/components/Sort/SortDialog'
import DropdownBar from '@ifca-root/react-component/src/components/SpecialBar/DropdownBar'
import { SearchBar } from '@ifca-root/react-component/src/components/SpecialBar/SearchBar'
import { SwapVert, Tune } from '@material-ui/icons'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { useFuseSearch } from 'helpers/Hooks/useSearch'
import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router'
import { AREntryList } from './ARListing/AREntryList'
import { ARPostingList } from './ARListing/ARPostingList'
import { useARListingData } from './Hooks/useARListingData'
import { SearchFilterV3 } from '@ifca-root/react-component/src/components/SpecialBar/SearchFilter/SearchFilterV3'

export const ARMain = (props: any) => {
  let history = useHistory()
  const { arSubmenu, routeSegments, accountType } = props

  const { CompanyID }: any = useParams()
  const approvalStatusEnum = [
    { name: 'All', ID: 'ALL' },
    { name: 'Draft', ID: 'ACTIVE' },
    { name: 'Submitted', ID: 'SUBMIT' },
    { name: 'Rejected', ID: 'REJECTED' },
    { name: 'Approved', ID: 'COMPLETED' },
  ]
  const getSearch = JSON.parse(localStorage.getItem('searchFilter'))
  const [postIDs, setPostIDs] = useState<Set<any>>(new Set([]))

  const {
    filteredList,
    handleSearch,
    setOriginalListing,
    originalList,
  } = useFuseSearch()

  const [errorDia, setErrorDia] = useState<boolean>(false)
  const [errMsg, setErrMsg] = useState<string>('')

  const [listStatus, setListStatus] = useState<string>(
    getSearch?.option ?? 'ACTIVE'
  )

  const {
    loading,
    primaryKey,
    createPermissionCheck,
    updatePermissionCheck,
    deletePermissionCheck,
    approveRejectPermissionCheck,
    userList,
    loadData,
  } = useARListingData({
    accountType,
    arSubmenu,
    CompanyID,
    setOriginalListing,
    filteredList,
    setErrMsg,
    setErrorDia,
  })

  useEffect(() => {
    setOriginalListing([])
    loadData({
      variables: {
        CompanyID,
        StatusArr:
          listStatus === 'ALL'
            ? ['ACTIVE', 'SUBMIT', 'REJECTED', 'COMPLETED']
            : [listStatus],
        take: 30,
        skip: 0,
        ...(getSearch?.name && { searchValue: getSearch?.name }),
        sortField: selectedField === null ? undefined : selectedField,
        sortOrder: sortOrder === null ? undefined : sortOrder,
        RoleID: user?.roleDetail?.RoleID,
        startDate: selectedStartDate === null ? undefined : selectedStartDate,
        endDate: selectedEndDate === null ? undefined : selectedEndDate,
      },
    })
  }, [listStatus])

  //to make delay for search function for the query to load
  const [timer, setTimer] = useState(null)
  function changeDelay(change) {
    if (timer) {
      clearTimeout(timer)
      setTimer(null)
    }

    setTimer(
      setTimeout(() => {
        setOriginalListing([])
        loadData({
          variables: {
            CompanyID: CompanyID,
            StatusArr:
              listStatus === 'ALL'
                ? ['ACTIVE', 'SUBMIT', 'REJECTED', 'COMPLETED']
                : [listStatus],
            take: 30,
            skip: 0,
            searchValue: change,
            sortField: selectedField === null ? undefined : selectedField,
            sortOrder: sortOrder === null ? undefined : sortOrder,
            RoleID: user?.roleDetail?.RoleID,
            startDate:
              selectedStartDate === null ? undefined : selectedStartDate,
            endDate: selectedEndDate === null ? undefined : selectedEndDate,
          },
        })
      }, 1000)
    )
  }

  const user = JSON.parse(localStorage.getItem('loggedInUser'))

  //*******************************************************//
  //-------------------SORTING DATA------------------------//
  //*******************************************************//

  const sortARDataDialog = [
    { ID: '1', value: 'DocNo', Name: 'Document No' },
    { ID: '2', value: 'RefNo', Name: 'Reference No' },
    { ID: '3', value: 'DocDate', Name: 'Document Date' },
    { ID: '4', value: 'Description', Name: 'Description' },
    { ID: '5', value: 'DocAmt', Name: 'Amount' },
    { ID: '6', value: 'CreditorName', Name: 'Debtor' },
  ]

  const [openSortDialog, setOpenSortDialog] = useState(false)
  const [selectedField, setSelectedField] = useState('')
  const [sortOrder, setSortOrder] = useState(null)

  const [openFilterDateDialog, setOpenFilterDateDialog] = useState(false)
  const [selectedStartDate, setSelectedStartDate] = useState(null)
  const [selectedEndDate, setSelectedEndDate] = useState(null)
  const [confirmedStartDate, setConfirmedStartDate] = useState(null)
  const [confirmedEndDate, setConfirmedEndDate] = useState(null)

  const handleClickSort = () => {
    setOpenSortDialog(true)
  }

  const handleListStatusChange = newStatus => {
    setSelectedStartDate(null)
    setSelectedEndDate(null)
    setListStatus(newStatus)
    setSelectedField(null)
    setSortOrder(null)
    setConfirmedStartDate(null)
    setConfirmedEndDate(null)
  }

  const handleSortConfirm = sortOption => {
    const { selectedField, sortOrder } = sortOption
    setOriginalListing([])
    loadData({
      variables: {
        CompanyID: CompanyID,
        StatusArr:
          listStatus === 'ALL'
            ? ['ACTIVE', 'SUBMIT', 'REJECTED', 'COMPLETED']
            : [listStatus],
        take: 30,
        skip: 0,
        searchValue:
          getSearch?.name === '' || getSearch?.name === undefined
            ? undefined
            : getSearch?.name,
        sortField: selectedField,
        sortOrder: sortOrder,
        startDate: selectedStartDate,
        endDate: selectedEndDate,
      },
    })
  }

  const handleClickDateRange = () => {
    setOpenFilterDateDialog(true)
  }

  const handleDateConfirm = () => {
    setOriginalListing([])
    loadData({
      variables: {
        CompanyID: CompanyID,
        StatusArr:
          listStatus === 'ALL'
            ? ['ACTIVE', 'SUBMIT', 'REJECTED', 'COMPLETED']
            : [listStatus],
        take: 30,
        skip: 0,
        RoleID: user?.roleDetail?.RoleID,
        searchValue:
          getSearch?.name === '' || getSearch?.name === undefined
            ? undefined
            : getSearch?.name,
        sortField: selectedField,
        sortOrder: sortOrder,
        startDate: selectedStartDate === null ? undefined : selectedStartDate,
        endDate: selectedEndDate === null ? undefined : selectedEndDate,
      },
    })
  }

  const handleDateReset = () => {
    setOriginalListing([])
    loadData({
      variables: {
        CompanyID: CompanyID,
        StatusArr:
          listStatus === 'ALL'
            ? ['ACTIVE', 'SUBMIT', 'REJECTED', 'COMPLETED']
            : [listStatus],
        take: 30,
        skip: 0,
        RoleID: user?.roleDetail?.RoleID,
        searchValue:
          getSearch?.name === '' || getSearch?.name === undefined
            ? undefined
            : getSearch?.name,
        sortField: selectedField,
        sortOrder: sortOrder,
        startDate: null,
        endDate: null,
      },
    })
  }

  return (
    <>
      {loading && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.push(`/account-receivable/${CompanyID}`)
          localStorage.removeItem(`searchFilter`)
        }}
        smTitle={'Account Receivable'}
        title={user?.companyName}
        routeSegments={[
          { name: 'Account Receivable' },
          { name: routeSegments, current: true },
        ]}
      />

      <div className="search-filter with-dropdown-filter">
        <SearchBar
          borderRadius="4px"
          onChangeAction={e => {
            localStorage.setItem(
              'searchFilter',
              JSON.stringify({
                option: listStatus ?? 'ACTIVE',
                name: e?.target?.value,
              })
            )
            changeDelay(e?.target?.value)
          }}
          isDefaultValue={!!getSearch}
          defaultValue={getSearch?.name ? getSearch?.name : ''}
          onCloseAction={() => {
            handleSearch('', [])
            setOriginalListing([])
            localStorage.removeItem('searchFilter')
            loadData({
              variables: {
                CompanyID: CompanyID,
                StatusArr:
                  listStatus === 'ALL'
                    ? ['ACTIVE', 'SUBMIT', 'REJECTED', 'COMPLETED']
                    : [listStatus],
                skip: 0,
                take: 30,
                RoleID: user?.roleDetail?.RoleID,
                sortField: selectedField === null ? undefined : selectedField,
                sortOrder: sortOrder === null ? undefined : sortOrder,
                startDate:
                  selectedStartDate === null ? undefined : selectedStartDate,
                endDate: selectedEndDate === null ? undefined : selectedEndDate,
              },
            })
          }}
          option={{
            icon: <Tune />,
            onClick: handleClickDateRange,
          }}
          sort={{
            icon: <SwapVert />,
            onClick: handleClickSort,
          }}
        />
        <SortDialog
          openSortDialog={openSortDialog}
          setOpenSortDialog={setOpenSortDialog}
          title="Sort Options"
          fieldList={sortARDataDialog}
          onSortConfirm={handleSortConfirm}
          selectedField={selectedField}
          setSelectedField={setSelectedField}
          sortOrder={sortOrder}
          setSortOrder={setSortOrder}
        />
        <SearchFilterV3
          openFilterDateDialog={openFilterDateDialog}
          setOpenFilterDateDialog={setOpenFilterDateDialog}
          handleDateConfirm={handleDateConfirm}
          currentStartDate={selectedStartDate}
          currentEndDate={selectedEndDate}
          setCurrentStartDate={setSelectedStartDate}
          setCurrentEndDate={setSelectedEndDate}
          handleDateReset={handleDateReset}
          confirmedStartDate={confirmedStartDate}
          confirmedEndDate={confirmedEndDate}
          setConfirmedStartDate={setConfirmedStartDate}
          setConfirmedEndDate={setConfirmedEndDate}
        />
        <DropdownBar
          options={approvalStatusEnum}
          setOptionID={handleListStatusChange}
          borderRadius="4px"
          defaultOption={approvalStatusEnum
            ?.map(opt => opt?.ID)
            .indexOf(listStatus ?? 'ACTIVE')}
          searchFilter={getSearch}
        />
      </div>

      {(listStatus === 'ACTIVE' ||
        listStatus === 'COMPLETED' ||
        listStatus === 'REJECTED' ||
        listStatus === 'ALL') && (
        // !loading &&
        <AREntryList
          arSubmenu={arSubmenu}
          loading={loading}
          filteredList={filteredList}
          listLoading={loading}
          listStatus={listStatus}
          userList={userList}
          primaryKey={primaryKey}
          createPermissionCheck={createPermissionCheck}
          updatePermissionCheck={updatePermissionCheck}
          deletePermissionCheck={deletePermissionCheck}
          loadData={loadData}
          CompanyID={CompanyID}
          setOriginalListing={setOriginalListing}
          getSearch={getSearch}
          selectedField={selectedField}
          sortOrder={sortOrder}
          selectedStartDate={selectedStartDate}
          selectedEndDate={selectedEndDate}
        />
      )}

      {listStatus === 'SUBMIT' && (
        // !loading &&
        <ARPostingList
          list={filteredList}
          loading={loading}
          filteredList={filteredList}
          listLoading={loading}
          listStatus={listStatus}
          postIDs={postIDs}
          setPostIDs={setPostIDs}
          userList={userList}
          approveRejectPermissionCheck={approveRejectPermissionCheck}
          setOriginalListing={setOriginalListing}
          arSubmenu={arSubmenu}
          loadData={loadData}
          CompanyID={CompanyID}
          getSearch={getSearch}
          selectedField={selectedField}
          sortOrder={sortOrder}
          selectedStartDate={selectedStartDate}
          selectedEndDate={selectedEndDate}
        />
      )}

      <ErrorDialog
        errorDia={errorDia}
        setErrorDia={setErrorDia}
        errorMsg={errMsg}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
